package com.bikompanion.domain

/**
 * Which language the rider asked for. [System] follows the device and has no [tag].
 *
 * [displayName] is the language's own name, never translated, so a rider can find theirs from
 * whichever language the app happens to be showing.
 */
enum class LanguagePreference(
    val tag: String?,
    val displayName: String,
) {
    System(tag = null, displayName = ""),
    Indonesian(tag = "id", displayName = "Bahasa Indonesia"),
    Catalan(tag = "ca", displayName = "Català"),
    German(tag = "de", displayName = "Deutsch"),
    English(tag = "en", displayName = "English"),
    Spanish(tag = "es", displayName = "Español"),
    Portuguese(tag = "pt", displayName = "Português"),
    Turkish(tag = "tr", displayName = "Türkçe"),
    Russian(tag = "ru", displayName = "Русский"),
    Arabic(tag = "ar", displayName = "العربية"),
    Hindi(tag = "hi", displayName = "हिन्दी"),
    Japanese(tag = "ja", displayName = "日本語"),
}
